import { SchemaFields } from "@redotech/redo-flows-core-schema-common/type-system/schema";

export const subscriptionUpsellSchemaFields = {
  hasSubscribableProduct: {
    dataType: "Boolean",
    documentation:
      "Whether anything in the cart can be offered as a subscription.",
  },
  subscribableProductInCartName: {
    dataType: "Maybe Text",
    documentation: "The name of a product the customer could subscribe to.",
  },
  // Minted at send time from `subscribableLines` rather than at trigger time,
  // because Storefront carts expire after ~30 days of inactivity.
  subscriptionCheckoutUrl: {
    dataType: "Maybe Url",
    documentation:
      "A checkout link pre-filled with the customer's subscribable products. Empty when they have none.",
  },
  subscribableLines: {
    dataType: "Maybe Multiple Subscription Cart Line",
    documentation:
      "Internal cart lines used to build the subscription checkout link.",
    hideFromInsertionModal: true,
    hideFromConditionStep: true,
  },
} as const satisfies SchemaFields;
